import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://dnywqquvsjizhxhjmnkk.supabase.co';
const SUPABASE_KEY = 'sb_publishable_IKDAmPCOMrMv0t_lCghDhw_UmUlluUj';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
